import ReadingJournalCard from "../ReadingJournalCard/ReadingJournalCard";
import { PageSerializersBooksLayout, ReadingJournalSerializersJournal, UserSerializersUserByline } from "types/serializers";

export default function ReadingJournals({
  book,
  user,
  journals,
  isOwner
}: {
  book: PageSerializersBooksLayout;
  journals: ReadingJournalSerializersJournal[]
  user: UserSerializersUserByline;
  isOwner: boolean;
}) {
  return (
    <div>
      {journals.map((journal) => (
        <ReadingJournalCard
          key={`journal-${journal.id}`}
          book={book}
          isOwner={isOwner}
          journal={journal}
          user={user}
          className="mt-2 bg-card p-4 rounded"
        />
      ))}
    </div>
  );
}
